"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const models_1 = require("../models");
const request_1 = require("../requests/request");
const jsonparser_1 = require("../requests/jsonparser");
class UserMev2 {
}
__decorate([
    jsonparser_1.JsonProperty({ type: 'true' }),
    __metadata("design:type", String)
], UserMev2.prototype, "ISHELPERMODEL", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'UserMev2' }),
    __metadata("design:type", String)
], UserMev2.prototype, "MODELNAME", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'User', clazz: models_1.User }),
    __metadata("design:type", models_1.User)
], UserMev2.prototype, "user", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'any' }),
    __metadata("design:type", Object)
], UserMev2.prototype, "membership", void 0);
exports.UserMev2 = UserMev2;
var RedirectPath;
(function (RedirectPath) {
    RedirectPath["MANAGE_SUBSCRIPTION"] = "account";
    RedirectPath["RECORD_POOL"] = "store/newreleases/audio/smart";
    RedirectPath["CLOUD_RESCUE"] = "account#cloudrescue";
})(RedirectPath = exports.RedirectPath || (exports.RedirectPath = {}));
class API {
    /**
     * Signs up a new user
     * @returns {Promise<Device>} The Promise contains an APIError if rejected
     * Error Types:
     * 400 InvalidParametersError
     * 403 ResourceAlreadyExists: Email already existing
     * 500 InternalServerError
     */
    static signUp(email, password, phone, full_name, from, device) {
        let apiRequest = new request_1.BasicRequest('/users', request_1.HTTPMethod.POST, request_1.APIVersion.v1_2, {}, {
            email: email,
            password: password,
            phone: phone,
            name: full_name,
            device: device,
            from
        });
        return apiRequest.send(models_1.Device).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the user
     * @returns {Promise<User>} The Promise contains an APIError if rejected
     */
    static getMe() {
        let apiRequest = new request_1.AuthenticatedRequest('/users/me', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(models_1.User).then((response) => {
            request_1.Session.getUserUpdatedHandler()(response.data);
            return response.data;
        });
    }
    /**
     * Fetches the user
     * @returns {Promise<User>} The Promise contains an APIError if rejected
     */
    static getMev2() {
        let apiRequest = new request_1.AuthenticatedRequest('/users/me', request_1.HTTPMethod.GET, request_1.APIVersion.v2_0);
        return apiRequest.send(UserMev2).then((response) => {
            request_1.Session.getUserUpdatedHandler()(response.data.user);
            return response.data;
        });
    }
    /**
     * Checks if the user has a Payment Instrument
     * @returns {Promise<User>} The Promise contains an APIError if rejected
     */
    static getPaymentInstrument(downwardCompatible = false, platform) {
        let apiRequest = new request_1.AuthenticatedRequest('/users/me/paymentInstrument', request_1.HTTPMethod.GET, request_1.APIVersion.v3_0, { downwardCompatible, platform });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    /**
     * Checks if the user has a Payment Instrument
     * @returns {Promise<User>} The Promise contains an APIError if rejected
     */
    static getCreditCard(platform) {
        let apiRequest = new request_1.AuthenticatedRequest('/users/me/credit-card', request_1.HTTPMethod.GET, request_1.APIVersion.v3_0, { platform });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    /**
     * Checks if HQ is allowed
     * @returns {Promise<User>} The Promise contains an APIError if rejected
     */
    static setHQ() {
        let apiRequest = new request_1.AuthenticatedRequest('/users/me/hq', request_1.HTTPMethod.PUT, request_1.APIVersion.v1_2);
        return apiRequest.send(models_1.User).then((response) => {
            request_1.Session.getUserUpdatedHandler()(response.data);
            return response.data;
        });
    }
    /**
     * Fetches the membership info
     * @returns {Promise<User>} The Promise contains an APIError if rejected
     */
    static getMembership() {
        let apiRequest = new request_1.AuthenticatedRequest('/users/me/membership', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        apiRequest.preventInvalidSubscriptionHandler = true;
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the membership info
     * @returns {Promise<User>} The Promise contains an APIError if rejected
     */
    static getMembershipv2() {
        let apiRequest = new request_1.AuthenticatedRequest('/users/me/membership', request_1.HTTPMethod.GET, request_1.APIVersion.v2_0);
        apiRequest.preventInvalidSubscriptionHandler = true;
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches a web redirect url
     * @returns {Promise<User>} The Promise contains an APIError if rejected
     */
    static getWebRedirect(type) {
        let apiRequest = new request_1.AuthenticatedRequest('/users/web/redirect', request_1.HTTPMethod.POST, request_1.APIVersion.v1_2, undefined, {
            path: type
        });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    /**
     * Updated the user's password
     * @returns {Promise<User>} The Promise contains an APIError if rejected
     */
    static changePassword(from, to) {
        let apiRequest = new request_1.AuthenticatedRequest('/users/me/change_password', request_1.HTTPMethod.POST, request_1.APIVersion.v1_2, undefined, {
            new_password: to,
            old_password: from
        });
        return apiRequest.send(models_1.User).then((response) => {
            return response.data;
        });
    }
    /**
     * Retrieves subscription update info
     * @returns {Promise<UpgradeInfo>} The Promise contains an APIError if rejected
     */
    static upgradeMembership() {
        let apiRequest = new request_1.AuthenticatedRequest('/users/membership/upgrade', request_1.HTTPMethod.POST, request_1.APIVersion.v1_2);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static setTheme(theme) {
        let apiRequest = new request_1.AuthenticatedRequest('/users/me/theme', request_1.HTTPMethod.PUT, request_1.APIVersion.v1_0, undefined, { theme });
        return apiRequest.send(models_1.User).then((response) => {
            request_1.Session.getUserUpdatedHandler()(response.data);
            return response.data;
        });
    }
    static logout() {
        let apiRequest = new request_1.AuthenticatedRequest('/logout', request_1.HTTPMethod.POST);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static getPayments(platform) {
        let apiRequest = new request_1.AuthenticatedRequest('/users/me/payments', request_1.HTTPMethod.GET, request_1.APIVersion.v1_0, { platform });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static getInvoiceLink(id, download) {
        return `${request_1.Session.getAPIURL()}/${request_1.APIVersion.v1_0}/order/${id}/invoice${download ? '?download=true' : ''}`;
    }
    static getAddress() {
        let apiRequest = new request_1.AuthenticatedRequest('/users/me/address', request_1.HTTPMethod.GET, request_1.APIVersion.v1_0);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static setAddress(address) {
        let apiRequest = new request_1.AuthenticatedRequest('/users/me/address', request_1.HTTPMethod.POST, request_1.APIVersion.v1_0, undefined, address);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    /**
     *
     * If code 403 is returned, to user name is already takes
     */
    static updateMe(update) {
        let apiRequest = new request_1.AuthenticatedRequest('/users/me', request_1.HTTPMethod.PUT, request_1.APIVersion.v1_0, undefined, update);
        return apiRequest.send(models_1.User).then((response) => {
            request_1.Session.getUserUpdatedHandler()(response.data);
            return response.data;
        });
    }
    static updateUser(id, user) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/user/' + id, request_1.HTTPMethod.PUT, request_1.APIVersion.v1_0, undefined, user);
        return apiRequest.send().then((response) => {
            request_1.Session.getUserUpdatedHandler()(response.data);
            return response.data;
        });
    }
    static loginWithUser(id) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/user/' + id + '/tempLogin', request_1.HTTPMethod.POST, request_1.APIVersion.v1_0);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static userById(id, withAdminRoleId) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/user/' + id, request_1.HTTPMethod.GET, request_1.APIVersion.v1_0, { withAdminRoleId });
        return apiRequest.send().then((response) => {
            request_1.Session.getUserUpdatedHandler()(response.data);
            return response.data;
        });
    }
    static getUsersMembership(platform, userId) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/user/' + userId + '/membership', request_1.HTTPMethod.GET, request_1.APIVersion.v1_0, { platform });
        apiRequest.preventInvalidSubscriptionHandler = true;
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    /**
     * Updated the user's password
     * @returns {Promise<User>} The Promise contains an APIError if rejected
     */
    static adminChangePassword(userId, password) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/user/' + userId + '/password', request_1.HTTPMethod.PUT, request_1.APIVersion.v1_0, undefined, {
            password,
        });
        return apiRequest.send(models_1.User).then((response) => {
            return response.data;
        });
    }
    /*public static adminPreviewPlanChange(userId: string, planId: number, prorata: boolean, coupon?: string): Promise<SubscriptionPackageChange> {
        let apiRequest = new AuthenticatedRequest<SubscriptionPackageChange>('/admin/user/' + userId + '/changeSubscription', HTTPMethod.PUT, APIVersion.v1_0, undefined, {
            preview: true,
            coupon,
            prorata,
            planId
        });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }

    public static adminChangePlan(userId: string, planId: number, prorata: boolean, coupon?: string): Promise<SubscriptionPackageChange> {
        let apiRequest = new AuthenticatedRequest<SubscriptionPackageChange>('/admin/user/' + userId + '/changeSubscription/' + planId, HTTPMethod.PUT, APIVersion.v1_0, undefined, {
            preview: false,
            coupon,
            prorata
        });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }*/
    static getAdminRoles() {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/user/admin/roles', request_1.HTTPMethod.GET, request_1.APIVersion.v1_0);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static resetDownloads(userId, ids) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/user/' + userId + '/downloads/resetMultiId', request_1.HTTPMethod.POST, request_1.APIVersion.v1_0, undefined, { ids });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static deleteProfilePicture() {
        let apiRequest = new request_1.AuthenticatedRequest('/users/me/picture', request_1.HTTPMethod.DELETE, request_1.APIVersion.v1_0);
        return apiRequest.send(models_1.User).then((response) => {
            request_1.Session.getUserUpdatedHandler()(response.data);
            return response.data;
        });
    }
    static uploadProfilePicture(image) {
        let apiRequest = new request_1.AuthenticatedFileRequest('/users/me/picture', request_1.HTTPMethod.POST, request_1.APIVersion.v1_0, undefined, {
            image
        });
        return apiRequest.send(models_1.User).then((response) => {
            request_1.Session.getUserUpdatedHandler()(response.data);
            return response.data;
        });
    }
}
exports.API = API;
